import React, { useEffect, useState, useRef } from 'react'

// next components
import { useRouter } from 'next/router'

// swiper
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper'
// Import Swiper styles
import 'swiper/css'
import 'swiper/css/navigation'

// custom functions
import { useViewport } from 'utils'

// resources
import { HomePrevButton } from 'components/Button/HomePrevButton'
import { HomeNextButton } from 'components/Button/HomeNextButton'

// styles
import styles from './index.module.scss'

// call apis
import dashboardAPI from 'apis/dashboard'
import FeaturedShopCard from 'components/Card/FeaturedShopCard'
import FeaturedShopCardMobile from 'components/Card/FeaturedShopCardMobile'

const FeaturedStoreSection = props => {
  const {} = props
  const viewport = useViewport()
  const router = useRouter()
  const [featuredStoreList, setFeaturedStoreList] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const swiperRef = useRef(null)

  const fetchShopPhysical = async () => {
    try {
      setIsLoading(true)
      const response = await dashboardAPI.getFeedData('featured-store')
      if (response && Array.isArray(response.cards)) {
        setFeaturedStoreList(response.cards)
      }
    } catch (error) {
      console.error('Error fetching shop physical data:', error)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchShopPhysical()
  }, [])

  useEffect(() => {
    if (!isLoading && swiperRef.current && featuredStoreList.length > 0) {
      // Use setTimeout to ensure DOM is fully rendered before repositioning
      const timer = setTimeout(() => {
        if (swiperRef.current) {
          // Force swiper to update and reposition slides after data loads
          swiperRef.current.update()
          swiperRef.current.slideToLoop(0, 0, false)
        }
      }, 100)
      return () => clearTimeout(timer)
    }
  }, [isLoading, featuredStoreList.length])

  const handlePrev = () => {
    if (swiperRef.current) {
      swiperRef.current.slidePrev()
    }
  }

  const handleNext = () => {
    if (swiperRef.current) {
      swiperRef.current.slideNext()
    }
  }

  return (
    <section className={styles.container}>
      <div className="w-full lg:h-[60px] h-[32px] g-container flex justify-between items-center">
        <div className={styles.headerContent}>
          <div className={styles.title}>Featured Stores</div>
        </div>
        <div className="lg:flex hidden items-end gap-5">
          <HomePrevButton onClick={() => handlePrev()} />

          <HomeNextButton onClick={() => handleNext()} />
        </div>
      </div>
      <div className={`${styles.editionSwiper} lg:block hidden mt-[25px]`}>
        <Swiper
          navigation={viewport === 'lg' || viewport === 'xl' || viewport === '2xl' ? true : false}
          slidesPerView={2.25}
          spaceBetween={viewport === 'lg' || viewport === 'xl' || viewport === '2xl' ? 20 : 11}
          centeredSlides={true}
          loop={featuredStoreList.length > 1}
          modules={[Navigation]}
          className={'heroMobileNavigationSwiper'}
          initialSlide={0}
          onSwiper={swiper => {
            swiperRef.current = swiper
            // Update swiper position after initialization if data is loaded
            if (featuredStoreList.length > 0 && !isLoading) {
              setTimeout(() => {
                if (swiper) {
                  swiper.update()
                  if (swiper.slideToLoop) {
                    swiper.slideToLoop(0, 0, false)
                  }
                }
              }, 50)
            }
          }}
        >
          {featuredStoreList.map((item, index) => (
            <SwiperSlide key={index}>
              <FeaturedShopCard data={item} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      {/* Mobile */}
      <div className={`w-full lg:hidden flex gap-[15px] overflow-x-auto mt-[15px] px-[16px] ${styles.hideScrollbar}`}>
        {featuredStoreList.map((item, index) => (
          <div key={index} className="max-w-[96%] min-w-[96%] h-[auto] overflow-hidden rounded-[15px]">
            <FeaturedShopCardMobile data={item} />
          </div>
        ))}
      </div>
    </section>
  )
}

export default FeaturedStoreSection
